import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Automatically attach active portfolio_id (from localStorage) as a query param
// for portfolio-scoped endpoints. Avoids passing it through every component.
const PORTFOLIO_KEY = "equitybox.active_portfolio_id";
const PORTFOLIO_SCOPED = /^\/(transactions|portfolio\/summary|portfolio\/benchmarks|portfolio\/sparklines|portfolio\/corporate-actions|portfolio\/report|portfolio\/whatif|portfolio\/share|prices\/refresh)(\/|$|\?)/;

api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (PORTFOLIO_SCOPED.test(url.startsWith("/") ? url : `/${url}`)) {
    const pid = localStorage.getItem(PORTFOLIO_KEY);
    if (pid) {
      config.params = { ...(config.params || {}), portfolio_id: pid };
    }
  }
  return config;
});
